import { styled, Box } from '@mui/material';

export const NoOptionsItemContainer = styled(Box)(() => ({
  display: 'flex',
  padding: '6px',
  gap: '8px',
  alignItems: 'center',
  cursor: 'pointer',
}));

export const NoOptionsItemIconContainer = styled(Box)(() => ({
  svg: { width: '20px', height: '20px' },
}));
